import React from 'react';
import { fetchAllExperiments, updateExperimentStatus, bulkUpdateExperimentStatus, fetchModerationStats } from '../../services/moderationService';
import SubmissionManager from '../admin/SubmissionManager';

// Only PENDING and NEEDS_UPDATE ever need a moderator's attention - everything
// else (approved/rejected) belongs on Manage Entries, not in this queue.
const QUEUE_STATUSES = ['PENDING', 'NEEDS_UPDATE'];

function Moderation() {
    return (
        <SubmissionManager
            title="Moderation Queue"
            subtitle="Review and update the status of pending and needs-update data contributions."
            fetchData={(page, size) => fetchAllExperiments(page, size, QUEUE_STATUSES)}
            fetchStats={fetchModerationStats}
            onAction={updateExperimentStatus}
            onBulkAction={bulkUpdateExperimentStatus}
            allowStatusFilter={true}
            statusFilterOptions={QUEUE_STATUSES}
            allowBulkActions={true}
            allowedActions={['APPROVED', 'REJECTED', 'PENDING', 'NEEDS_UPDATE']}
            emptyMessage="No submissions awaiting review."
        />
    );
}

export default Moderation;
